import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Transaction } from '../../../models/transactions';
import EditTransactionForm from '../forms/edit-transaction-form';

interface Props {
  show: boolean;
  transaction?: Transaction;
  onEdited: () => void;
  onClose: () => void;
}

function EditTransactionModal({ show, onEdited, onClose, transaction }: Props) {
  const { t } = useTranslation();

  if (!transaction) return null;

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('EDIT_TRANSACTION_MODAL.TITLE')}</DialogTitle>
      <DialogContent dividers>
        <EditTransactionForm
          transaction={transaction}
          onSuccess={onEdited}
          onCancel={onClose}
          isDialog={true}
        />
      </DialogContent>
    </Dialog>
  );
}

export default EditTransactionModal;
